import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../global";

const Paypal = ({ business, amount, currencyCode = "USD", receiver_user_key, payoutKey }) => {
    const formRef = useRef(null);

    const custom = {
        type: 2,
        payer_user_key: sessionStorage.getItem("pk_user_key"),
        receiver_user_key: receiver_user_key,
        payout_key: payoutKey,
    };

    const jsonCustom = JSON.stringify(custom);

    const handleProceed = (e) => {
        if (!amount) {
            toast.warning("Please select a plan.", {
                autoClose: 3000,
            });
            return;
        }
        // if (!payoutKey) {
        //     toast.warning("Invalid Key.", {
        //         autoClose: 3000,
        //     });
        //     return;
        // }

        // Submit the form programmatically
        if (formRef.current) {
            formRef.current.submit();
        }
    };

    return (
        <form ref={formRef} action="https://www.sandbox.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_xclick" />
            <input type="hidden" name="business" value={business} />
            <input type="hidden" name="currency_code" value="USD" />
            <input type="hidden" name="amount" value={amount} />
            <input type="hidden" name="item_name" value="Request Payment" />
            {/* <input type="hidden" name="item_number" value={sessionStorage.getItem("pk_user_key")} /> */}
            <input type="hidden" name="return" value={BASE_URL + "admin/admin-payout"} />
            <input type="hidden" name="cancel_return" value={BASE_URL + "admin/admin-payout"} />
            {/* <input type="hidden" name="return" value={"http://localhost:3000/2024/paperboy/" + "admin/admin-payout"} />
            <input type="hidden" name="cancel_return" value={"http://localhost:3000/2024/paperboy/" + "admin/admin-payout"} /> */}
            <input type="hidden" name="notify_url" value={BASE_URL + "API/pay_notify.php"} />
            {/* <input type="hidden" name="image_url" value={BASE_URL + "API/logo.png"} /> */}
            <input type="hidden" name="image_url" value={BASE_URL + "API/paperboy_paypal_logo.png"} />
            {/* <input type="hidden" name="custom" value={subKey} /> */}
            <input type="hidden" name="custom" value={jsonCustom} />
            {/* <button type="submit">Pay</button> */}

            <button type="button" onClick={handleProceed} className="btn btn-dark text-white d-flex align-items-center justify-content-center fw-semibold">
                Pay
            </button>
        </form>
    );
};

export default Paypal;
